import { render, staticRenderFns } from "./carikartgenelamaclirapor.vue?vue&type=template&id=ff6dccd0&scoped=true&"
import script from "./carikartgenelamaclirapor.vue?vue&type=script&lang=js&"
export * from "./carikartgenelamaclirapor.vue?vue&type=script&lang=js&"
import style0 from "./carikartgenelamaclirapor.vue?vue&type=style&index=0&id=ff6dccd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6dccd0",
  null
  
)

export default component.exports